import {Branding} from '../Branding.types'

import LogoAFGWhite from './icons/Logo-Alex-Fraser-White.svg'
import LogoAFG from './icons/Logo-Alex-Fraser.svg'

export const hubAlexFraserAu: Branding = {
  nationalBrandName: 'Alex Fraser',
  nationalLogoUrl: LogoAFGWhite,
  nationalLogoTitle: 'Alex Fraser Group',
  onWhiteLogoUrl: LogoAFG,
  nationalUrl: 'https://www.hub.alexfraser.com.au/',
  contactEmail: 'digital@alexfraser.com.au',
  contactEmailSubject: 'Mail from Alex Fraser Group',
  safetyDataSheetLink: 'https://www.heidelbergmaterials.us/resources/safety-data-sheets',
  pageTitle: 'Alex Fraser Group',
  country: 'AU',
  termsAndConditionsOfSale: 'https://www.heidelbergmaterials.com.au/en/terms-and-conditions-of-sale'
}
